import { createContext } from 'react';
export const NavigatorContext = createContext({
    navigatorState: 'drawer-open',
    toggleNavigator: () => void 0,
});
//# sourceMappingURL=NavigatorContext.js.map